import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

function TimerComponent() {
  const [seconds, setSeconds] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const [playerNames, setPlayerNames] = useState("");

  useEffect(() => {
    setInterval(() => {
      let ip = document.getElementById("ip");
      if (ip && ip.value){
        ip = ip.value;
      }else{
        ip = "localhost"
      }
      fetch(`http://${ip}:8080/getTimerList`).then((r)=>r.text()).then((r) =>
        setPlayerNames(r)
      );
    }, 1000);
  }, []);

  function toggle() {
    setIsActive(!isActive);
  }

  function reset() {
    fetch(
      `http://${
        document.getElementById("ip").value ?? "localhost"
      }:8080/timerStop`
    ).then((res) => {
      setSeconds(0);
      setIsActive(false);
    });
  }

  function startListning() {
    fetch(
      `http://${
        document.getElementById("ip").value ?? "localhost"
      }:8080/listenToTimer?playerName=${
        document.getElementById("playerNum").value
      }`
    ).then((r)=>r.text()).then((res) => {
      if (res == "started") {
        setSeconds(0);
        setIsActive(true);
      }
    });
  }

  function startForAll() {
    fetch(
      `http://${
        document.getElementById("ip").value ?? "localhost"
      }:8080/timerStart`
    ).then((res) => {
    //   setSeconds(0);
    //   setIsActive(true);
    });
  }

  useEffect(() => {
    let interval = null;
    if (isActive) {
      interval = setInterval(() => {
        setSeconds((seconds) => seconds + 1);
      }, 1000);
    } else if (!isActive && seconds !== 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isActive, seconds]);

  return (
    <div>
      <div style={{ textAlign: "center", padding: "3px", fontSize: "80px" }}>
        {Math.floor(seconds / 60)}:
        {seconds % 60 < 10 ? `0${seconds % 60}` : seconds % 60}
      </div>
      <div style={{ textAlign: "center", padding: "3px" }}>
        <Button onClick={toggle} style={{ margin: "1px" }}>
          {isActive ? "Pause" : "Start Locally"}
        </Button>
        <Button onClick={reset} style={{ margin: "1px" }}>
          Reset
        </Button>
      </div>
      <div style={{ textAlign: "center", padding: "3px" }}>
        <Button onClick={startListning} style={{ margin: "1px" }}>
          Start Listening
        </Button>
        <Button onClick={startForAll} style={{ margin: "1px" }}>
          Start for All
        </Button>
      </div>
      <div>{playerNames}</div>
    </div>
  );
}

export default TimerComponent;
